import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import es from 'vuetify/es5/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        //primary: '#6A8BAD',
        //secondary: '#304457',
        //accent: '#1d2935', //1d2935//126DA4
        //error: '#E83030',
        //info: '#03C2E6',
        //success: '#42B983',
        //warning: '#EA6E00'
        
        primary: '#0055FF',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
    lang: {
      locales: { es },
      current: 'es',
    },
  icons: {
    iconfont: 'fa',
  },
});
